import { ICampaignV2Api } from './campaign-v2.api'
import { liveCampaignV2Api } from './campaign-v2.live'

/** The flow talks to the real backend; there is no in-browser demo. */
export const campaignV2Api = (): ICampaignV2Api => liveCampaignV2Api

export type { ICampaignV2Api } from './campaign-v2.api'
